import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useContactForm } from "../features/useContactForm";
import { WA_URL, TG_URL, IG_URL, PHONE_RAW, PHONE_DISPLAY, EMAIL } from "../config/constants";
import "./Contact.css";

export default function Contact() {
  const { t } = useTranslation("contact");
  const { fields, status, handleFieldChange, handleSubmit } = useContactForm();

  return (
    <main>
      <Helmet>
        <title>Contact Us — ProNet Real Estate Dubai</title>
        <meta name="description" content="Get in touch with ProNet Real Estate. Call, WhatsApp, or email us to find your perfect property in Dubai and across the UAE." />
        <link rel="canonical" href="https://pronet-realestate.com/contact" />
        <meta property="og:title" content="Contact Us — ProNet Real Estate Dubai" />
        <meta property="og:description" content="Get in touch with ProNet Real Estate. Call, WhatsApp, or email us to find your perfect property in Dubai and across the UAE." />
        <meta property="og:url" content="https://pronet-realestate.com/contact" />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="contact-hero">
        <div className="container">
          <p className="contact-eyebrow">{t("hero.eyebrow")}</p>
          <h1 className="contact-title">{t("hero.title")}</h1>
          <p className="contact-sub">{t("hero.sub")}</p>
        </div>
      </section>

      <div className="container contact-layout">
        <div className="contact-info">
          <div className="info-block">
            <h3>{t("info.phoneTitle")}</h3>
            <a href={`tel:${PHONE_RAW}`} className="info-link">{PHONE_DISPLAY}</a>
            <div className="info-chips">
              <a href={WA_URL} target="_blank" rel="noreferrer" className="info-btn btn-whatsapp">WhatsApp</a>
              <a href={TG_URL} target="_blank" rel="noreferrer" className="info-btn btn-telegram">Telegram</a>
            </div>
          </div>
          <div className="info-block">
            <h3>{t("info.emailTitle")}</h3>
            <a href={`mailto:${EMAIL}`} className="info-link">{EMAIL}</a>
          </div>
          <div className="info-block">
            <h3>{t("info.socialTitle")}</h3>
            <a href={IG_URL} target="_blank" rel="noreferrer" className="info-link">@pronet_real_estate</a>
          </div>
          <div className="info-block">
            <h3>{t("info.hoursTitle")}</h3>
            <p className="info-text">{t("info.hours1")}</p>
            <p className="info-text">{t("info.hours2")}</p>
            <p className="info-text">{t("info.hours3")}</p>
          </div>
        </div>

        <div className="contact-form-wrap">
          {status === "sent" ? (
            <div className="form-success">
              <h2>{t("form.successTitle")}</h2>
              <p>{t("form.successSub")}</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <h2 className="form-title">{t("form.title")}</h2>

              <div className="form-row">
                <div className="form-group">
                  <label>{t("form.name")}</label>
                  <input type="text" placeholder={t("form.namePh")} value={fields.name} onChange={handleFieldChange("name")} required />
                </div>
                <div className="form-group">
                  <label>{t("form.email")}</label>
                  <input type="email" placeholder="your@email.com" value={fields.email} onChange={handleFieldChange("email")} required />
                </div>
              </div>

              <div className="form-group">
                <label>{t("form.phone")}</label>
                <input type="tel" placeholder="+971..." value={fields.phone} onChange={handleFieldChange("phone")} />
              </div>

              <div className="form-group">
                <label>{t("form.message")}</label>
                <textarea rows={5} placeholder={t("form.messagePh")} value={fields.message} onChange={handleFieldChange("message")} required />
              </div>

              {status === "error" && <p className="form-error">{t("form.error")}</p>}

              <button type="submit" className="form-submit" disabled={status === "sending"}>
                {status === "sending" ? t("form.sending") : t("form.submit")}
              </button>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
